// @see https://www.postgresql.org/docs/current/errcodes-appendix.html
export const TRANSACTION_ROLLBACK_ERROR_PREFIX = '40';
